// extracted by mini-css-extract-plugin
export default {"main":"UploadCSV_main__RKFep","upload":"UploadCSV_upload__0b2pP","upload-csv":"UploadCSV_upload-csv__CTIs3","details":"UploadCSV_details__aWAsQ"};